/**
 * openNewTab
 * Opens a given URL in a new browser tab.
 * - Prevents default event behavior
 * - Focuses on new tab if allowed by browser
 */
export const openNewTab = (e, url) => {
  e.preventDefault();
  const newWindow = window.open(url, "_blank");
  if (newWindow) {
    newWindow.focus();
  }
};

/**
 * openMail
 * Opens the default email client with given address.
 * - Uses mailto: protocol
 */
export const openMail = (e, email) => {
  e.preventDefault();
  window.location.href = `mailto:${email}`;
};
